// The wordmark and its two Blue Ice keys, laid out as in the 2026 brand guidelines
const WIDTH = 312;
const HEIGHT = 60.6712;

export const Logo = ({ width = 125 }) => (
  <svg
    role="img"
    aria-label="Keystrike"
    width={width}
    height={(width * HEIGHT) / WIDTH}
    viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
    style={{ display: 'block' }}
  >
    <image href="/logo-wordmark.svg" width="265" height={HEIGHT} />
    <rect x="292" y="0" width="20" height="20" rx="3.179" fill="#1057FA" />
    <rect x="279" y="23" width="20" height="20" rx="3.179" fill="#1057FA" />
  </svg>
);
